import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';

export interface IPageBaseLayout {
  quizCompleted?: boolean;
}

export const PageBaseLayout: React.FC<React.PropsWithChildren<IPageBaseLayout>> = props => {
  return (
    <div className={cn(styles['wrapper'], props.quizCompleted && styles['quiz_completed'])}>
      <div className={styles['container']}>{props.children}</div>
    </div>
  );
};

PageBaseLayout.displayName = 'PageBaseLayout';
